import React from 'react';
import styled from 'styled-components';
import { backgroundLightM } from 'web-ui-kit/colors';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;
/**
 * A small spacer element.
 */


function SectionBreak(_ref) {
  var _ref$mqHide = _ref.mqHide,
      mqHide = _ref$mqHide === void 0 ? undefined : _ref$mqHide;
  return (
    /*#__PURE__*/
    React.createElement(Spacer, {
      mqHide: mqHide
    })
  );
}

var Spacer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 0.5rem;\n  width: 100%;\n\n  ", "\n"])), backgroundLightM, function (p) {
  return p.mqHide && "\n    ".concat(p.mqHide, " {\n      display: none;\n    }\n  ");
});
export default SectionBreak;